import * as Raven from "@sentry/browser";
import { SmartApplyApiError } from "../application/apis/api-error";

export const reportAsyncError = (e: Error) => {
  if (process.env.REACT_APP_ENVIRONMENT === "local") {
    alert(e);
    console.log(e);
  } else {
    if (canIgnore(e)) {
      return;
    }

    if (SmartApplyApiError.isApiError(e)) {
      // APIによってはe.error.config.dataに申請内容が含まれる場合があり、個人情報がSentryに送信されてしまう。当該propertyを取り除くことでそれを防ぐ。
      // e.errorをAxiosErrorにcastすれば型安全にconfig.dataを取り除くことも出来るが、そこまでコストをかけるほどの処理ではないと判断して簡易に対応する。
      delete (e.error as any)?.config?.data;
      delete (e.error as any)?.request?.["__sentry_xhr__"]?.body;
      delete (e.error as any)?.response?.request?.["__sentry_xhr__"]?.body;
      Raven.captureException(e.error);
    } else {
      Raven.captureException(e);
    }
  }
};

export const reportUnexpectedError = (e: Error) => {
  const errorCode = SmartApplyApiError.errorCode(e) || "";
  if (
    !errorCode.startsWith("unauthorized") &&
    !errorCode.startsWith("forbidden") &&
    !SmartApplyApiError.isErrorCode(e, "not_found")
  ) {
    reportAsyncError(new SmartApplyApiError(e));
  }
};

const canIgnore = (e: any): boolean => {
  if (SmartApplyApiError.isApiError(e)) {
    const responseStr = JSON.stringify(e.response);
    if (
      typeof responseStr === "string" &&
      isDigitalArtsIncServerBusy(responseStr)
    ) {
      return true;
    }
  }

  return (
    e instanceof Error &&
    typeof e.message === "string" &&
    isDigitalArtsIncServerBusy(e.message)
  );
};

// 顧客環境で利用している Digital Arts社のプロキシがエラー原因のケース。
// 具体的には北九州市さまなど。
// 自社でどうすることもできないのでレポートから無視する対象としている。
// https://www.daj.jp/
const isDigitalArtsIncServerBusy = (message: string): boolean => {
  return (
    typeof message === "string" &&
    typeof message.includes === "function" &&
    message.includes("Digital Arts Inc.") &&
    (message.includes("混雑している可能性があります") ||
      message.includes(
        "サーバーが存在しないか、接続拒否している可能性があります",
      ) || // https://sentry.io/organizations/graffer-inc/issues/2557462756/events/d9aaa9107ad04ea297fa3a5fa611e49c/?project=5094779
      message.includes("上位プロキシサーバーが見つかりません。")) // https://sentry.io/organizations/graffer-inc/issues/2508053974/events/6c13a323526d468c8f3257c02c6287f5/?project=5094779
  );
};
